export const sorActiveAttemptUrl = (organizationId: number, claimId: number): string =>
  `/api/v1/organizations/${organizationId}/claims/${claimId}/sor/active`;

/** The System of Record's Issues tab in system configuration. */
export const SOR_ISSUES_PAGE_URL = '/sysconfig/operations/system-of-record/issues';
